export default "__VITE_ASSET__1YohDpdn__"